export default __webpack_public_path__ + "static/media/5h.562a2074.svg";